import HttpService from './http.service';

class PackageService {
  getPackages() {
    return HttpService.get('packages')
      .then((res) => res.data);
  }

  suggestPackages(params) {
    return HttpService.get('packages/suggestions', { params })
      .then((res) => res.data);
  }

  getPackage(id) {
    return HttpService.get(`packages/${id}`)
      .then((res) => res.data);
  }

  createPackage(productPackage) {
    return HttpService.post('packages', productPackage)
      .then((res) => res.data);
  }

  updatePackage(productPackage) {
    return HttpService.patch(`packages/${productPackage.id}`, productPackage)
      .then((res) => res.data);
  }

  deletePackage(productPackage) {
    return HttpService.delete(`packages/${productPackage.id}`)
      .then((res) => res.data);
  }
}

export default new PackageService();
